__webpack_require__.p = "https://nashezoloto.axiom-ai.alexipro.ru/";